module.exports = __webpack_public_path__ + "img/arrow-big-dark.1e40f18b.svg";